import produce from 'immer'
import { v4 as uuidv4 } from 'uuid'

import {
  TOAST_SHOWN,
  CLEAR_TOAST,
  ADD_TEMPLATE_SUCCESS,
  ADD_TEMPLATE_FAILURE,
  UPDATE_TEMPLATE_SUCCESS,
  UPDATE_TEMPLATE_FAILURE,
  REMOVE_TEMPLATE_SUCCESS,
  REMOVE_TEMPLATE_FAILURE,
  ADD_INDEX_SUCCESS,
  ADD_INDEX_FAILURE,
  UPDATE_INDEX_SUCCESS,
  UPDATE_INDEX_FAILURE,
  REMOVE_INDEX_SUCCESS,
  REMOVE_INDEX_FAILURE,
  ADD_ALIAS_SUCCESS,
  ADD_ALIAS_FAILURE,
  UPDATE_ALIAS_SUCCESS,
  UPDATE_ALIAS_FAILURE,
  REMOVE_ALIAS_SUCCESS,
  REMOVE_ALIAS_FAILURE,
  FETCH_STATUSES_FAILURE,
  FETCH_ALIASES_FAILURE,
  FETCH_INDICES_FAILURE,
  FETCH_TEMPLATES_FAILURE,
  FETCH_INDEX_FAILURE,
  FETCH_TEMPLATE_FAILURE,
  FETCH_ALIAS_FAILURE,
  FETCH_BRANDS_AGGREGATES_FAILURE,
  FETCH_CONTENT_TYPES_AGGREGATES_FAILURE,
  FETCH_DOCUMENTS_AGGREGATES_FAILURE,
  FETCH_BRANDS_FAILURE,
  FETCH_VERSIONS_FAILURE,
  FETCH_CONTENT_TYPES_FAILURE,
  FETCH_BRAND_STATUS_FAILURE,
  FETCH_BRAND_PROGRESS_FAILURE,
  REINDEX_BRAND_FAILURE,
  STOP_REINDEX_FAILURE,
  REINDEX_BY_ID_SUCCESS,
  REINDEX_BY_ID_FAILURE,
  SET_VERSIONS_SUCCESS,
  SET_VERSIONS_FAILURE,
  FETCH_QUEUES_FAILURE,
  FETCH_QUEUE_COUNTS_FAILURE,
  TRIGGER_SERVICE_FAILURE,
  TRIGGER_SERVICE_SUCCESS,
  RETRY_DLQ_MESSAGES_FAILURE,
  RETRY_DLQ_MESSAGES_SUCCESS,
  FETCH_CONFIGURATION_FAILURE,
  FETCH_EXCLUSION_FILES_FAILURE,
  FETCH_EXCLUSION_FILE_FAILURE,
  ADD_EXCLUSION_FILE_SUCCESS,
  ADD_EXCLUSION_FILE_FAILURE,
  UPDATE_EXCLUSION_FILE_SUCCESS,
  UPDATE_EXCLUSION_FILE_FAILURE,
  REMOVE_EXCLUSION_FILE_SUCCESS,
  REMOVE_EXCLUSION_FILE_FAILURE,
  SET_AUTO_VERSIONING_VERSION_FAILURE,
  SET_AUTO_VERSIONING_BRANDS_FAILURE,
  AUTO_VERSIONING_UNCONFIRM_FAILURE,
  AUTO_VERSIONING_KICKOFF_SUCCESS,
  AUTO_VERSIONING_KICKOFF_FAILURE,
  FETCH_AUTO_VERSIONING_PROGRESS_FAILURE,
  AUTO_VERSIONING_RESET_FAILURE,
  AUTO_VERSIONING_CANCEL_SUCCESS,
  AUTO_VERSIONING_CANCEL_FAILURE,
  AUTO_VERSIONING_ROLLBACK_SUCCESS,
  AUTO_VERSIONING_ROLLBACK_FAILURE,
  CLEAR_DLQ_FAILURE,
  CLEAR_DLQ_SUCCESS,
  FETCH_VERTICALS_FAILURE,
  FETCH_SELENE_VERSIONS_FAILURE,
  FETCH_TEMPLATE_TYPES_FAILURE,
  FETCH_VERTICAL_STATUS_FAILURE,
  FETCH_VERTICAL_PROGRESS_FAILURE,
  REINDEX_VERTICAL_FAILURE,
  STOP_SELENE_REINDEX_FAILURE,
  REINDEX_SELENE_BY_ID_SUCCESS,
  REINDEX_SELENE_BY_ID_FAILURE,
  SET_SELENE_VERSIONS_FAILURE,
  SET_SELENE_VERSIONS_SUCCESS,
} from '../actions/types'

export const initialToastState = {
  id: '',
  time: new Date(),
  title: '',
  message: '',
  variant: 'info',
  shown: false,
}

export const initialState = {
  allIds: [],
  byId: {},
}

const generateMessage = (title, message, variant) => ({ id: uuidv4(), title, message, variant, time: new Date() })

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case TOAST_SHOWN: {
      const toastId = payload
      draft.byId[toastId].shown = true
      break
    }
    case CLEAR_TOAST: {
      const toastId = payload
      const idx = draft.allIds.indexOf(toastId)
      draft.allIds.splice(idx, 1)
      delete draft.byId[toastId]
      break
    }

    // ELASTIC
    case ADD_TEMPLATE_SUCCESS: {
      const { templateName } = payload
      const msg = generateMessage('Template added', `Successfully added template ${templateName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case ADD_TEMPLATE_FAILURE: {
      const { templateName, error } = payload
      const msg = generateMessage('Failed to add template', `Failed to add template ${templateName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case UPDATE_TEMPLATE_SUCCESS: {
      const { templateName } = payload
      const msg = generateMessage('Template updated', `Successfully updated template ${templateName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case UPDATE_TEMPLATE_FAILURE: {
      const { templateName, error } = payload
      const msg = generateMessage('Failed to update template', `Failed to update template ${templateName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REMOVE_TEMPLATE_SUCCESS: {
      const { templateName } = payload
      const msg = generateMessage('Template removed', `Successfully removed template ${templateName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REMOVE_TEMPLATE_FAILURE: {
      const { templateName, error } = payload
      const msg = generateMessage('Failed to remove template', `Failed to remove template ${templateName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case ADD_INDEX_SUCCESS: {
      const { indexName } = payload
      const msg = generateMessage('Index added', `Successfully added index ${indexName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case ADD_INDEX_FAILURE: {
      const { indexName, error } = payload
      const msg = generateMessage('Failed to add index', `Failed to add index ${indexName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case UPDATE_INDEX_SUCCESS: {
      const { indexName } = payload
      const msg = generateMessage('Index updated', `Successfully updated index ${indexName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case UPDATE_INDEX_FAILURE: {
      const { indexName, error } = payload
      const msg = generateMessage('Failed to update index', `Failed to update index ${indexName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REMOVE_INDEX_SUCCESS: {
      const { indexName } = payload
      const msg = generateMessage('Index removed', `Successfully removed index ${indexName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REMOVE_INDEX_FAILURE: {
      const { indexName, error } = payload
      const msg = generateMessage('Failed to remove index', `Failed to remove index ${indexName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case ADD_ALIAS_SUCCESS: {
      const { aliasName, indexName } = payload
      const msg = generateMessage('Alias added', `Successfully added alias ${aliasName} for index ${indexName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case ADD_ALIAS_FAILURE: {
      const { aliasName, indexName, error } = payload
      const msg = generateMessage('Failed to add alias', `Failed to add alias ${aliasName} for index ${indexName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case UPDATE_ALIAS_SUCCESS: {
      const { aliasName, indexName } = payload
      const msg = generateMessage('Alias updated', `Successfully updated alias ${aliasName} for index ${indexName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case UPDATE_ALIAS_FAILURE: {
      const { aliasName, indexName, error } = payload
      const msg = generateMessage('Failed to update alias', `Failed to update alias ${aliasName} for index ${indexName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REMOVE_ALIAS_SUCCESS: {
      const { aliasName, indexName } = payload
      const msg = generateMessage('Alias removed', `Successfully removed alias ${aliasName} for index ${indexName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REMOVE_ALIAS_FAILURE: {
      const { aliasName, indexName, error } = payload
      const msg = generateMessage('Failed to remove alias', `Failed to remove alias ${aliasName} for index ${indexName}:\n${error.message}`, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_STATUSES_FAILURE: {
      const msg = generateMessage('Failed to fetch statuses', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_ALIASES_FAILURE: {
      const msg = generateMessage('Failed to fetch aliases', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_INDICES_FAILURE: {
      const msg = generateMessage('Failed to fetch indices', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_TEMPLATES_FAILURE: {
      const msg = generateMessage('Failed to fetch templates', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_INDEX_FAILURE: {
      const { error } = payload
      const msg = generateMessage('Index mapping not found', error.message, 'warning')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_TEMPLATE_FAILURE: {
      const { error } = payload
      const msg = generateMessage('Error fetching template', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_ALIAS_FAILURE: {
      const { error } = payload
      const msg = generateMessage('Error fetching alias', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }

    // ELASTIC VISUALIZATIONS
    case FETCH_BRANDS_AGGREGATES_FAILURE:
    case FETCH_CONTENT_TYPES_AGGREGATES_FAILURE:
    case FETCH_DOCUMENTS_AGGREGATES_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching elastic aggregates', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }

    // REINDEX
    case FETCH_BRANDS_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching brands', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_VERTICALS_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching verticals', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_VERSIONS_FAILURE:
    case FETCH_SELENE_VERSIONS_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching indexer versions', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_CONTENT_TYPES_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching content types', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_TEMPLATE_TYPES_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching template types', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_BRAND_STATUS_FAILURE: {
      const { error, brandName } = payload
      const msg = generateMessage(`Error fetching status for brand: ${brandName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_VERTICAL_STATUS_FAILURE: {
      const { error, verticalName } = payload
      const msg = generateMessage(`Error fetching status for vertical: ${verticalName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_BRAND_PROGRESS_FAILURE: {
      const { error, brandName } = payload
      const msg = generateMessage(`Error fetching brand progress for brand: ${brandName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_VERTICAL_PROGRESS_FAILURE: {
      const { error, verticalName } = payload
      const msg = generateMessage(`Error fetching brand progress for vertical: ${verticalName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REINDEX_BRAND_FAILURE: {
      const { error, brandName } = payload
      const msg = generateMessage(`Error starting reindex for brand: ${brandName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REINDEX_VERTICAL_FAILURE: {
      const { error, verticalName } = payload
      const msg = generateMessage(`Error starting reindex for vertical: ${verticalName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case STOP_REINDEX_FAILURE: {
      const { error, brandName } = payload
      const msg = generateMessage(`Error stopping reindex for brand: ${brandName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }

    case STOP_SELENE_REINDEX_FAILURE: {
      const { error, verticalName } = payload
      const msg = generateMessage(`Error stopping reindex for vertical: ${verticalName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REINDEX_BY_ID_SUCCESS:
    case REINDEX_SELENE_BY_ID_SUCCESS: {
      const msg = generateMessage('Documents reindexed', 'Successfully sent the documents off to be reindexed.', 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REINDEX_BY_ID_FAILURE:
    case REINDEX_SELENE_BY_ID_FAILURE: {
      const error = payload
      const msg = generateMessage('Error reindexing documents by id', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case SET_VERSIONS_FAILURE:
    case SET_SELENE_VERSIONS_FAILURE: {
      const error = payload
      const msg = generateMessage('Error setting indexer versions', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case SET_VERSIONS_SUCCESS:
    case SET_SELENE_VERSIONS_SUCCESS: {
      const msg = generateMessage('Indexer versions updated', 'Successfully updated Indexer versions.', 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }

    // QUEUES
    case FETCH_QUEUES_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching queues', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_QUEUE_COUNTS_FAILURE: {
      const { queueId, error } = payload
      const msg = generateMessage(`Error fetching counts for queue ${queueId}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case TRIGGER_SERVICE_SUCCESS: {
      const { queueId } = payload
      const msg = generateMessage('Service triggered', `Successfully triggered service ${queueId}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case TRIGGER_SERVICE_FAILURE: {
      const { queueId, error } = payload
      const msg = generateMessage(`Error triggering service for queue ${queueId}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case RETRY_DLQ_MESSAGES_SUCCESS: {
      const { queueId } = payload
      const msg = generateMessage('DLQ messages retried', `Successfully retried DLQ messages for queue ${queueId}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case RETRY_DLQ_MESSAGES_FAILURE: {
      const { queueId, error } = payload
      const msg = generateMessage(`Error retrying DLQ messages for ${queueId}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case CLEAR_DLQ_SUCCESS: {
      const { queueId } = payload
      const msg = generateMessage('DLQ messages cleared', `Successfully cleared DLQ messages for queue ${queueId}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case CLEAR_DLQ_FAILURE: {
      const { queueId, error } = payload
      const msg = generateMessage(`Error clearing DLQ messages for ${queueId}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }

    // CONFIGURATION
    case FETCH_CONFIGURATION_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching configuration values', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }

    // EXCLUSIONS
    case FETCH_EXCLUSION_FILES_FAILURE: {
      const error = payload
      const msg = generateMessage('Error fetching exclusion files', error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_EXCLUSION_FILE_FAILURE: {
      const { fileName, error } = payload
      const msg = generateMessage(`Error fetching exclusion file ${fileName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case ADD_EXCLUSION_FILE_SUCCESS: {
      const fileName = payload
      const msg = generateMessage('Exclusion file added', `Successfully added exclusion file ${fileName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case ADD_EXCLUSION_FILE_FAILURE: {
      const { fileName, error } = payload
      const msg = generateMessage(`Error adding exclusion file ${fileName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case UPDATE_EXCLUSION_FILE_SUCCESS: {
      const fileName = payload
      const msg = generateMessage('Exclusion file updated', `Successfully updated exclusion file ${fileName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case UPDATE_EXCLUSION_FILE_FAILURE: {
      const { fileName, error } = payload
      const msg = generateMessage(`Error updating exclusion file ${fileName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REMOVE_EXCLUSION_FILE_SUCCESS: {
      const fileName = payload
      const msg = generateMessage('Exclusion file removed', `Successfully removed exclusion file ${fileName}`, 'success')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case REMOVE_EXCLUSION_FILE_FAILURE: {
      const { fileName, error } = payload
      const msg = generateMessage(`Error removing exclusion file ${fileName}`, error.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }

    // AUTO VERSIONING
    case SET_AUTO_VERSIONING_VERSION_FAILURE: {
      const msg = generateMessage('Error setting auto versioning index version', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case SET_AUTO_VERSIONING_BRANDS_FAILURE: {
      const msg = generateMessage('Error setting auto versioning brands', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case AUTO_VERSIONING_UNCONFIRM_FAILURE: {
      const msg = generateMessage('Error going back in auto versioning', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case AUTO_VERSIONING_KICKOFF_SUCCESS: {
      const msg = generateMessage('Auto versioning kicked off', 'Successfully started auto versioning for brands', 'info')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case AUTO_VERSIONING_KICKOFF_FAILURE: {
      const msg = generateMessage('Error kicking off auto versioning', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case FETCH_AUTO_VERSIONING_PROGRESS_FAILURE: {
      const msg = generateMessage('Error fetching status for auto versioning', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case AUTO_VERSIONING_RESET_FAILURE: {
      const msg = generateMessage('Error resetting auto versioning', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case AUTO_VERSIONING_CANCEL_SUCCESS: {
      const msg = generateMessage('Auto versioning cancelled', 'Successfully cancelled auto versioning wizard', 'info')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case AUTO_VERSIONING_CANCEL_FAILURE: {
      const msg = generateMessage('Error cancelling auto versioning', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case AUTO_VERSIONING_ROLLBACK_SUCCESS: {
      const msg = generateMessage('Auto versioning roll-back has begun', 'Successfully started roll-back for auto versioning wizard', 'info')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    case AUTO_VERSIONING_ROLLBACK_FAILURE: {
      const msg = generateMessage('Error rolling-back auto versioning', payload.message, 'danger')
      draft.allIds.push(msg.id)
      draft.byId[msg.id] = msg
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
